import { FC } from 'react';

import CheckboxGroup from '@/components/ui/CheckboxGroup';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DAMAGE_RIGHTS_ASSIGNMENTS = {
  DAMAGE_AOB: 'damage_aob',
  DAMAGE_RIGHTS_AUTHORIZATIONS: 'damage_rights_authorizations',
  DAMAGE_RIGHTS_POA: 'damage_rights_poa',
  ANY: 'any',
} as const;

export const DAMAGE_RIGHTS_ASSIGNMENTS_NAME = 'damage_rights_assignments';
export const DAMAGE_RIGHTS_ASSIGNMENTS_NAME_COMPLEMENTARY =
  'damage_rights_assignments_complementary';
interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const CheckboxGroupDamageRightsAssignments: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? DAMAGE_RIGHTS_ASSIGNMENTS_NAME_COMPLEMENTARY
      : DAMAGE_RIGHTS_ASSIGNMENTS_NAME);

  return (
    <div id={name} className="overflow-initial scroll-mt-10">
      <FormField
        control={control}
        name={fieldName}
        rules={{
          required: {
            value: true,
            message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
          },
        }}
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              {i18n.t(
                'Czy były zawierane jakiekolwiek cesje, pełnomocnictwa, upoważnienia praw do szkody (np. na warsztaty, wypożyczalnie, firmy odszkodowawcze, kancelarie)?'
              )}
            </FormLabel>
            <FormControl>
              <CheckboxGroup
                field={field}
                data-testid={
                  isComplementary
                    ? DAMAGE_RIGHTS_ASSIGNMENTS_NAME_COMPLEMENTARY
                    : DAMAGE_RIGHTS_ASSIGNMENTS_NAME
                }
                options={[
                  {
                    value: DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_AOB,
                    label: i18n.t('Cesje'),
                  },
                  {
                    value:
                      DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_RIGHTS_AUTHORIZATIONS,
                    label: i18n.t('Upoważnienia'),
                  },
                  {
                    value: DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_RIGHTS_POA,
                    label: i18n.t('Pełnomocnictwa'),
                  },
                  {
                    value: DAMAGE_RIGHTS_ASSIGNMENTS.ANY,
                    label: i18n.t('Nie'),
                    willResetRest: true,
                  },
                ]}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
